import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HomeAespa, HomeRiize, WaitingAespa, WaitingRiize } from '../pages';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/riize" replace />} />
        <Route path="/riize" element={<HomeRiize />} />
        <Route path="/aespa" element={<HomeAespa />} />
        <Route path="/riize/waiting" element={<WaitingRiize />} />
        <Route path="/aespa/waiting" element={<WaitingAespa />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
